"use client";

import { TolgeeProvider } from "@tolgee/react";
import { tolgee } from "@/lib/tolgee";
import { useLanguage } from "@/context/language-context";
import { useEffect } from "react";

export function TolgeeWrapper({ children }: { children: React.ReactNode }) {
  const { language } = useLanguage();

  useEffect(() => {
    tolgee.changeLanguage(language);
  }, [language]);

  return (
    <TolgeeProvider tolgee={tolgee} fallback={children}>
      {children}
    </TolgeeProvider>
  );
}
